
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsQueueDialog extends Serenity.EntityDialog<PsQueueRow, any> {
        protected getFormKey() { return PsQueueForm.formKey; }
        protected getIdProperty() { return PsQueueRow.idProperty; }
        protected getLocalTextPrefix() { return PsQueueRow.localTextPrefix; }
        protected getNameProperty() { return PsQueueRow.nameProperty; }
        protected getService() { return PsQueueService.baseUrl; }
        protected getDeletePermission() { return PsQueueRow.deletePermission; }
        protected getInsertPermission() { return PsQueueRow.insertPermission; }
        protected getUpdatePermission() { return PsQueueRow.updatePermission; }

        protected form = new PsQueueForm(this.idPrefix);

    }
}